ACMS.Ready(function () {
	const minDate = new Date();
	const maxDate = new Date();
	minDate.setDate(minDate.getDate() + 7);
	maxDate.setDate(maxDate.getDate() + 60);
	ACMS.Config.flatDatePickerConfig.minDate = minDate.getFullYear() + '-' + (parseInt(minDate.getMonth(), 10) + 1) + '-' + minDate.getDate();
	ACMS.Config.flatDatePickerConfig.maxDate = maxDate.getFullYear() + '-' + (parseInt(maxDate.getMonth(), 10) + 1) + '-' + maxDate.getDate();
	ACMS.Config.flatDatePickerConfig.disable = [
		function (date) {
			return (date.getDay() === 0 || date.getDay() === 4 || date.getDay() === 6);
		}
	];
});
